import styled from 'styled-components'

import { breakpoints, colors, fontWeights } from '@/styles'

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0 auto 100px;
  width: 95%;
  max-width: 1096px;

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    width: 100%;
    padding: 0 20px;
  }
`

export const Title = styled.h2`
  font-family: futura-pt, sans-serif;
  color: ${colors.regular};
  font-size: 38px;
  font-weight: 500;
  margin-bottom: 30px;

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 34px;
  }
`

export const CityInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 14px;
`

export const CityInfoMain = styled.div`
  padding: 30px 0;
  border-top: 1px solid ${colors.grey};
`

export const SectionTitle = styled.h3`
  font-size: 21px;
  font-weight: ${fontWeights.medium};
  letter-spacing: -0.58px;
  line-height: 26px;
  margin: 0 0 20px;
`

export const Description = styled.p`
  font-size: 14px;
  margin: 0;

  a {
    color: ${colors.secondary};
    transition: opacity 0.1s ease-in-out;

    :hover {
      opacity: 0.7;
    }
  }

  :not(:last-child) {
    margin-bottom: 20px;
  }
`

export const FaqSection = styled.div`
  p:first-child {
    font-weight: 600;
    margin: 0;
  }

  p:not(:first-child) {
    margin: 10px 0;
  }

  p:last-child {
    margin: 10px 0 20px;
  }

  :last-child {
    p:last-child {
      margin-bottom: 0;
    }
  }
`
